import MedicalSerializer from './base';

export default class Medication extends MedicalSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      allowSiblingUse: false,
      deleted: false,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
